import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import { UserStatus, MessageTypes } from 'storage/user/user.model';
import { errorFormEvent } from 'utils/events';
import sendEvent from 'utils/sendEvent';
import { Alert } from 'components/Alert';

import InvalidPasswordError from './components/InvalidPasswordError';
import AccountBlocked from './components/AccountBlocked';
import AccountIsNotActive from './components/AccountIsNotActive';
import AccountIsNotSynced from './components/AccountIsNotSynced';

interface IErrorMessage {
  messageType: UserStatus;
}

const ErrorMessage = ({ messageType }: IErrorMessage) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (messageType === MessageTypes.invalidPassword) {
      sendEvent({
        labelText: t('PAGE_LOGIN_ERROR_TITLE'),
        ...errorFormEvent
      });
    }
    if (messageType === MessageTypes.blocked) {
      sendEvent({
        labelText: t('PAGE_LOGIN_ACCOUNT_BLOCKED_TITLE'),
        ...errorFormEvent
      });
    }
    if (messageType === MessageTypes.notActivated) {
      sendEvent({
        labelText: t('PAGE_LOGIN_ACCOUNT_NOT_ACTIVATED_TITLE'),
        ...errorFormEvent
      });
    }
    if (messageType === MessageTypes.sessionExpired) {
      sendEvent({
        labelText: t('PAGE_LOGIN_SESSION_EXPIRED'),
        ...errorFormEvent
      });
    }
  }, [messageType]);

  if (messageType === MessageTypes.blocked) {
    return <AccountBlocked />;
  }

  if (messageType === MessageTypes.invalidPassword) {
    return <InvalidPasswordError />;
  }
  if (messageType === MessageTypes.notActivated) {
    return <AccountIsNotActive />;
  }
  if (messageType === MessageTypes.notSynced) {
    return <AccountIsNotSynced />;
  }
  if (messageType === MessageTypes.sessionExpired) {
    return (
      <Alert
        variant="standard"
        severity="warning"
        title={t('PAGE_LOGIN_SESSION_EXPIRED')}
        sx={{ marginBottom: '10px' }}
      >
        <Typography component="span" variant="body2">
          {t('PAGE_LOGIN_ACCOUNT_SESSION_EXPIRED_MESSAGE')}
        </Typography>
      </Alert>
    );
  }
  return null;
};

export default ErrorMessage;
